import $ from 'jquery';

export default () => {
    $('html').removeClass('js-disabled').addClass('js-enabled');
};
